import gql from "graphql-tag";

export default gql`
  mutation updateAsset($assetInput: AssetInputInput, $customerId: ID, $assetId: ID) {
    updateAsset(assetInput: $assetInput, customerId: $customerId, assetId: $assetId) {
      id
      customerId
    }
  }
`;
